import Loadable from 'react/components/loadable';

const ReturnToDashboardV1Modal = Loadable({
  loader: () => import('../../pages/dashboard/components/return_to_dashboard_v1_modal'),
  type: 'modal',
});

angular.module('gym').value('ReturnToDashboardV1Modal', ReturnToDashboardV1Modal);
